import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { AlertsDashboardAction } from './alertsDashboard.action';
import { alertsDashboardInitialState } from './alertsDashboard.constans';
import { IAlertsDashboardStore } from './alertsDashboard.interface';

export const alertsDashboardReducer = reducerWithInitialState(alertsDashboardInitialState)
  .case(AlertsDashboardAction.updateFilter, (state, payload): IAlertsDashboardStore => {
    return {
      ...state,
      filter: {
        ...state.filter,
        ...payload,
      },
    };
  })
  .case(AlertsDashboardAction.updateFrom, (state, payload): IAlertsDashboardStore => {
    return {
      ...state,
      filter: {
        ...state.filter,
        fromTimestamp: payload?.valueOf(),
      },
    };
  })
  .case(AlertsDashboardAction.updateTo, (state, payload): IAlertsDashboardStore => {
    return {
      ...state,
      filter: {
        ...state.filter,
        toTimestamp: payload?.valueOf(),
      },
    };
  })
  .case(AlertsDashboardAction.getNextPage, (state): IAlertsDashboardStore => {
    return {
      ...state,
      nextRequestTimestamp: Date.now(),
    };
  })
  .case(AlertsDashboardAction.togglePolling, (state): IAlertsDashboardStore => {
    return {
      ...state,
      isPollingEnabled: !state.isPollingEnabled,
    };
  })
  .case(AlertsDashboardAction.setPollingEnabled, (state, isPollingEnabled): IAlertsDashboardStore => {
    return {
      ...state,
      isPollingEnabled,
    };
  })
  .case(AlertsDashboardAction.loadAlertList.done, (state): IAlertsDashboardStore => {
    return {
      ...state,
      lastUpdatedAt: Date.now(),
    };
  })
  .case(AlertsDashboardAction.destroy, (): IAlertsDashboardStore => {
    return {
      ...alertsDashboardInitialState,
    };
  });
